import CommonUtils from '../../../shared/utils/utils-common';
import { CollectionTypeEnum } from '../../../store/api';

export interface CopyDetailsPopupSorting {
    readonly key: string;
    readonly label: string;
    readonly comparator: (a: any, b: any) => number;
}

const statusSorting: CopyDetailsPopupSorting = {
    key: 'status',
    label: 'Status',
    comparator: (
        a: { status: string; orderNumber: string; startDate: number },
        b: { status: string; orderNumber: string; startDate: number }
    ) => {
        if (a.status === b.status) {
            return CommonUtils.cmp(b.orderNumber, a.orderNumber) || b.startDate - a.startDate;
        }
        if (a.status === 'Roll-over') {
            return -1;
        }
        if (b.status === 'Roll-over') {
            return 1;
        }
        if (a.status === 'Active') {
            return -1;
        }
        if (b.status === 'Active') {
            return 1;
        }
        return CommonUtils.cmp(b.orderNumber, a.orderNumber) || b.startDate - a.startDate;
    }
};

export const CopyDetailsPopupLocalContentSorting: CopyDetailsPopupSorting[] = [
    {
        key: 'startDate',
        label: 'Start Date',
        comparator: (a: { startDate: number; orderNumber: any }, b: { startDate: number; orderNumber: any }) =>
            b.startDate - a.startDate || CommonUtils.cmp(b.orderNumber, a.orderNumber)
    },
    {
        key: 'expiryDate',
        label: 'Expiry Date',
        comparator: (
            a: { expiryDate: number; orderNumber: any; startDate: number },
            b: { expiryDate: number; orderNumber: any; startDate: number }
        ) => b.expiryDate - a.expiryDate || CommonUtils.cmp(b.orderNumber, a.orderNumber) || b.startDate - a.startDate
    },
    {
        key: 'shipDate',
        label: 'Ship Date',
        comparator: (a: { shipDate: number; orderNumber: any }, b: { shipDate: number; orderNumber: any }) =>
            b.shipDate - a.shipDate || CommonUtils.cmp(b.orderNumber, a.orderNumber) || statusSorting.comparator(a, b)
    },
    {
        key: 'usageCount',
        label: 'Usage Count',
        comparator: (
            a: { usageCount: number; orderNumber: string; startDate: number },
            b: { usageCount: number; orderNumber: string; startDate: number }
        ) => b.usageCount - a.usageCount || CommonUtils.cmp(b.orderNumber, a.orderNumber) || b.startDate - a.startDate
    },
    {
        key: 'collection',
        label: 'Collection',
        comparator: (
            a: { collectionType: CollectionTypeEnum; collection: CollectionTypeEnum },
            b: { collectionType: CollectionTypeEnum; collection: CollectionTypeEnum }
        ) => CommonUtils.cmp(a.collectionType, b.collectionType) || CommonUtils.cmp(a.collection, b.collection)
    },
    statusSorting
];

export const CopyDetailsPopupDefaultSorting: CopyDetailsPopupSorting[] = [
    {
        key: 'order',
        label: 'Order',
        comparator: (a: { orderNumber: any; startDate: number }, b: { orderNumber: any; startDate: number }) =>
            CommonUtils.cmp(b.orderNumber, a.orderNumber) || b.startDate - a.startDate || statusSorting.comparator(a, b)
    },
    {
        key: 'invoice',
        label: 'Invoice',
        comparator: (
            a: { invoice: any; orderNumber: any; startDate: number },
            b: { invoice: any; orderNumber: any; startDate: number }
        ) =>
            CommonUtils.cmp(b.invoice, a.invoice) ||
            CommonUtils.cmp(b.orderNumber, a.orderNumber) ||
            b.startDate - a.startDate
    },
    ...CopyDetailsPopupLocalContentSorting
];
